import styled, { css } from 'styled-components';
import { ThemeColours } from '../../../../styles/ThemeColours';
import {
  FontSize,
  FontWeight,
  FONT_STACK,
  LineHeight,
  PRESSABLE,
} from '../../../../styles/constants';
import { Link } from '../../../Link';

export const LinksView = styled.div`
  ${FONT_STACK};
  color: ${ThemeColours.black};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  padding: 24px;
  user-select: none;
`;

const linkStyle = css`
  ${PRESSABLE};
  color: inherit;
  cursor: pointer;
  display: block;
  font-size: ${FontSize.SUB_HEADING};
  margin-bottom: 16px;
  text-decoration: none;
  width: fit-content;

  &:hover {
    text-decoration: underline;
  }
`;

export const LogoutLink = styled.span.attrs({ 'data-testid': 'LogoutLink' })`
  ${linkStyle}
  font-size: ${FontSize.LARGE};
  font-weight: ${FontWeight.REGULAR};
  line-height: ${LineHeight.LARGE};
  margin: 26px 0 0px;
`;

export const HomeWrapper = styled.div`
  align-items: flex-end;
  display: flex;
  flex-grow: 1;
  margin-top: 26px;
  min-height: 32px;
`;

export const HomeLink = styled(Link)`
  ${PRESSABLE};
  display: block;
  width: 108px;
`;
